export default "__VITE_ASSET__Bi2dnvs7__"